import { Component } from '@angular/core';
import { NavbarComponent } from '../../components/navbar/navbar.component'; 
import { FormLogginComponent } from '../../components/form-loggin/form-loggin.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loggin',
  imports: [
    NavbarComponent,
    FormLogginComponent,
    FooterComponent
  ],
  templateUrl: './loggin.component.html',
  styleUrl: './loggin.component.css'
})
export class LogginComponent {
 
  username: string = '';
  password: string = '';
  errorMessage: string = '';
  isLoading: boolean = false;


  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}


  async handleLogin() {
    try {
      await this.authService.signIn(this.username, this.password);

      // Log usuario tras login
      const user = this.authService['tokenStorage'].getUser();
      console.log('[Login] Usuario tras login:', user);

      // Prioridad de grupos: superadmin > admin-hotel > admin-recepcion > user
      const groupPriority = [
        { group: 'superadmin', route: '/superadmin' },
        { group: 'admin-hotel', route: '/admin-hotel' },
        { group: 'admin-recepcion', route: '/admin-recepcion' },
        { group: 'user', route: '/' }
      ];
      const userGroups: string[] = user?.groups || [];
      let redirected = false;
      for (const { group, route } of groupPriority) {
        if (userGroups.includes(group)) {
          console.log(`[Login] Redirigiendo a ${route} por grupo ${group}`);
          this.router.navigate([route]);
          redirected = true;
          break;
        }
      }
      if (!redirected) {
        // Si no tiene grupo conocido, redirigir a home
        this.router.navigate(['/']);
      }
    } catch (error) {
      console.error('Login error:', error);
      this.errorMessage = 'Credenciales incorrectas';
    }
  }
}
